import { collection, doc, addDoc, updateDoc, deleteDoc, runTransaction } from 'firebase/firestore';
import { db } from '../firebase';
import { parseTranscript } from './utils/transcript';

export function recordingNotesApi(userId) {
  const notes = collection(db, 'teachers', userId, 'recordingNotes');
  return {
    notes,
    create: () => addDoc(notes, { title: 'Untitled note', content: '', transcript: '', updated_at: new Date().toISOString() }),
    updateNote: async (id, patch) => {
      await updateDoc(doc(notes, id), { ...patch, updated_at: new Date().toISOString() });
    },
    deleteNote: (id) => deleteDoc(doc(notes, id)),
    appendTranscript: (id, text, elapsedMs) => runTransaction(db, async (transaction) => {
      const reference = doc(notes, id);
      const snapshot = await transaction.get(reference);
      if (!snapshot.exists()) throw new Error('This note no longer exists.');
      const transcript = parseTranscript(snapshot.data().transcript);
      transcript.push({ text, elapsedMs, at: new Date().toISOString() });
      const updated = { ...snapshot.data(), id, transcript: JSON.stringify(transcript), updated_at: new Date().toISOString() };
      transaction.update(reference, { transcript: updated.transcript, updated_at: updated.updated_at });
      return updated;
    }),
  };
}
